import axios from "axios";
import {getConfig} from '../helpers/config';

export class ComuneService {

	baseAPIUrl = `${getConfig()?.url}comuni`;

	getById = async (id) => {
		return await axios.get(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	getAll = async () => {
		return await axios.get(`${this.baseAPIUrl}/`)
											.then(res => res.data);
	}

	getAllByTipologia = async (tipologia) => {
		return await axios.get(`${this.baseAPIUrl}/tipologia/${tipologia}`)
											.then(res => res.data);
	}

	getAllByTipologiaAndDenominazioneRegione = async (tipologia, denominazioneRegione, dismessi) => {
		return await axios.get(`${this.baseAPIUrl}/tipologia/${tipologia}/regione/${denominazioneRegione}${dismessi ? '?dismessi=' + dismessi : ''}`)
											.then(res => res.data);
	}

	getAllByTipologiaAndProvincia = async (tipologia, provincia) => {
		return await axios.get(`${this.baseAPIUrl}/tipologia/${tipologia}/provincia/${provincia}`)
											.then(res => res.data);
	}

	getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia = async (bandoId, tipologia, denominazioneRegione, provincia) => {
		return await axios.get(`${this.baseAPIUrl}/bando/${bandoId}/tipologia/${tipologia}/regione/${denominazioneRegione}${provincia ? '?denominazioneProvincia=' + provincia : ''}`)
											.then(res => res.data);
	}

	getAllDt = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/dt`, data)
											.then(res => res.data);
	}

	create = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	update = async (data) => {
		return await axios.put(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	delete = async (id) => {
		return await axios.delete(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	associate = async (userId, enteId) => {
		return await axios.put(`${this.baseAPIUrl}/${userId}/${enteId}`)
											.then(res => res.data);
	}

	remove = async (userId, enteId) => {
		return await axios.delete(`${this.baseAPIUrl}/${userId}/${enteId}`)
											.then(res => res.data);
	}

	aderisci = async (enteId, bandoId) => {
		return await axios.put(`${this.baseAPIUrl}/adesione/${enteId}/${bandoId}`)
											.then(res => res.data);
	}

	rimuoviAdesione = async (enteId, bandoId) => {
		return await axios.delete(`${this.baseAPIUrl}/adesione/${enteId}/${bandoId}`)
											.then(res => res.data);
	}

	rimuoviReferenteDaComune = async (enteId, codiceFiscale) => {
		return await axios.delete(`${this.baseAPIUrl}/referente/${enteId}/${codiceFiscale}`)
											.then(res => res.data);
	}

	getAllProvince = async () => {
		return await axios.get(`${this.baseAPIUrl}/province`)
											.then(res => res.data.map(el => { return { key: el, value: el } }));
	}

	getAllProvinceByRegione = async (nomeRegione) => {
		return await axios.get(`${this.baseAPIUrl}/province/${nomeRegione}`)
											.then(res => res.data.map(el => { return { key: el, value: el } }));
	}
}
